import React, {useState,useEffect} from 'react';
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {Inc,Owner,Bill} from './Inc';
import RowTable from './RowTable';
import {Tools} from './Tools';
import BillList from './BillList';
import Ajax from './Ajax';
import Loading from './Loading';
import PaymentConfirm from './PaymentConfirm';
import PaymentForm from './PaymentForm';
import Title from './Title';

interface Props {
	owner:Owner,
	managerId:number,
}

const PaymentDetail = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const defBills:Bill[] = [];
    const [states,setStates] = useState({
        isConfirm:false,
        isLoading:true,
        bills:defBills,
		//bank: Inc.defaultOwnerBank(),
		bank: {} as any,
        payment:Inc.defaultPayment(),
		paymentOne:Inc.defaultPayment(),
		numOwners: 0,
    });
	const [tabIndex, setTabIndex] = useState(0);

	const changeTab = (event: React.SyntheticEvent, newValue: number) => {
	  setTabIndex(newValue);
	};
  
    const loadPayment = ()=>{
        Ajax.send("payment/get",{customer_id:props.owner.customer.customer_id},(res:any)=>{
            //console.log("payment/get",res);
            if( res.ok ){
                setStates({...states,
					"isLoading":false,
					"isConfirm":false,
					"payment":res.payment,
					"paymentOne":res.payment_one,
					"bills":res.bills,
					"bank":res.bank,
					"numOwners":res.num_owners,
				})
            }
        });
    }
    const confirm = ()=>{
        setStates({...states,isConfirm:true});
    }
    const yes = ()=>{
        setStates({...states,"isLoading":true})
        Ajax.send("payment/do",{},(res:any)=>{
            if( res.ok ){
                loadPayment();
            }
        });        
    }
    const no = ()=>{
        setStates({...states,isConfirm:false});
    }
    const cancel = ()=>{
        setStates({...states,"isLoading":true})
        states.payment.last && Ajax.send("payment/cancel",{bill_id:states.payment.last.bill_id},(res:any)=>{
            if( res.ok ){
                loadPayment();
            }
        });        
    }

    useEffect( ()=>{
        window.scrollTo(0,0);
        loadPayment();
    } ,[]);

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}
	
    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        )
    }

    const toFirst = "first/p4";
    const toBank = "bank";

	return (
		<div id="profile_detail" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    {(states.payment.last && states.payment.last.status==="0" && props.owner.owner_id===props.managerId) &&
                    <Hidden mdUp implementation="js">
                        <Paper className={classes.paper} style={{marginBottom:"1em"}}>
                            <Title text="支払申請中" size={2}/>
                            <PaymentForm confirm={confirm} cancel={cancel} bill={states.payment.last} apply={states.payment.amount>states.payment.cost}/>
                        </Paper>
                    </Hidden>
                    }
                    <Paper className={classes.paper}>
                        <Title text="売上残高" icon="trending"/>
                        <div style={{marginBottom:"2em"}}>
                        現在の売上残高と差し引かれる手数料は以下の通りです。差引金額から支払手数料（110円～210円）を引いた金額が実際の振込金額になります。<br/>
						{props.managerId===props.owner.owner_id ? (
                        <span>残高の支払いをご希望の場合は、「支払口座」が設定されていることをご確認の上、 「支払申請する」をクリックして下さい。</span>
						):(
						<span>残高の支払いをご希望の場合は、プロフィールをメインプロフィールに切り替えて下さい。</span>
						)}
                        </div>
						{states.numOwners>1 &&
						<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
							<Tabs value={tabIndex} onChange={changeTab} aria-label="basic tabs example">
							<Tab label={props.owner.owner_name+"だけ"}/>
							<Tab label="全プロフィールの合算"/>
							</Tabs>
						</Box>
						}
						{(tabIndex===0 && states.numOwners>1) &&
                        <Table style={{marginBottom:"1em"}}>
                            <TableBody>
                                <RowTable name="売上残高" value={
                                    <div style={{textAlign:"right",fontSize:"140%"}}>
                                    {Tools.comma(states.paymentOne.sales)}円
                                    </div>
                                }/>
                                <RowTable name="販売手数料" value={
                                    <div style={{textAlign:"right",fontSize:"140%"}}>
                                    -{Tools.comma(states.paymentOne.fee)}円
                                    </div>
                                }/>
                                <RowTable name="商品返送料等" value={
                                    <div style={{textAlign:"right",fontSize:"140%"}}>
                                    -{Tools.comma(states.paymentOne.fee_etc)}円
                                    </div>
                                }/>
                                <RowTable name="差引金額" value={
                                    <div style={{textAlign:"right",fontSize:"140%"}}>
                                    {Tools.comma(states.paymentOne.amount)}円
                                    </div>
                                }/>
                            </TableBody>
                        </Table>
						}
						{(tabIndex===1 || states.numOwners===1) &&
                        <Table style={{marginBottom:"1em"}}>
                            <TableBody>
                                <RowTable name="売上残高" value={
                                    <div style={{textAlign:"right",fontSize:"140%"}}>
                                    {Tools.comma(states.payment.sales)}円
                                    </div>
                                }/>
                                <RowTable name="販売手数料" value={
                                    <div style={{textAlign:"right",fontSize:"140%"}}>
                                    -{Tools.comma(states.payment.fee)}円
                                    </div>
                                }/>
                                <RowTable name="商品返送料等" value={
                                    <div style={{textAlign:"right",fontSize:"140%"}}>
                                    -{Tools.comma(states.payment.fee_etc)}円
                                    </div>
                                }/>
                                <RowTable name="差引金額" value={
                                    <div style={{textAlign:"right",fontSize:"140%"}}>
                                    {Tools.comma(states.payment.amount)}円
                                    </div>
                                }/>
                            </TableBody>
                        </Table>
						}
                    </Paper>
					{props.managerId===props.owner.owner_id &&
                    <Paper className={classes.paper} style={{marginTop:"1em"}}>
                        <BillList bills={states.bills} owner={props.owner}/>
                    </Paper>
					}
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					{props.owner.owner_id===props.managerId ? (
                    <Paper className={classes.paper}>
                        {states.payment.last && states.payment.last.status==="0" ? (
                        <React.Fragment>
                            <Hidden mdDown implementation="js">
                                <Title text="支払申請中" size={2}/>
                                <PaymentForm confirm={confirm} cancel={cancel} bill={states.payment.last} apply={states.payment.amount>states.payment.cost && states.bank.complete}/>
                                <Divider style={{marginBottom:"1em"}}/>
                            </Hidden>
                            <Hidden mdUp implementation="js">
                            	<Title text="支払申請" size={2}/>
                            </Hidden>
                        </React.Fragment>
                        ):(
                        <React.Fragment>
                            <Title text="支払申請" size={2}/>
                            <PaymentForm confirm={confirm} cancel={cancel} bill={states.payment.last} apply={states.payment.amount>states.payment.cost && states.bank.complete}/>
                        </React.Fragment>
                        )}
                        <FormControl fullWidth={true} style={{marginBottom:"1em"}}>
                            <a href={toBank}><Button variant="outlined" color="primary" style={{width:"100%"}}><VisibilityIcon/>支払口座の登録・変更</Button></a>
                        </FormControl>
                        <ul className={classes.guideUl}>
                            <li className={classes.guideLi}>支払手数料は支払1回ごとに、ゆうちょの場合110円、銀行・信用金庫の場合210円かかります。これは指定口座への振込手数料を含みます。</li>
                            <li className={classes.guideLi}>原則として、支払申請をしてから1週間以内にお振込いたします。ただし、年末年始等の長期休暇により、2週間程度お待ちいただく場合もあります。</li>
                            <li className={classes.guideLi}>振込予定日が決定するまでには、支払申請をしてから1営業日程度かかりますのでお待ち下さい。</li>
                            <li className={classes.guideLi}>支払申請中は、振込が完了するまで、次の支払申請はできません。</li>
                            <li className={classes.guideLi}>申請後24時間まではいつでもキャンセルが可能です。それ以降のキャンセルはお問い合わせフォームからご相談下さい。（手続きが間に合わない場合があります）</li>
                            <li className={classes.guideLi}>口座番号が正しくないなどの理由で振り込みができなかった場合は、自動的にキャンセルとなります。キャンセル理由をメールでお知らせいたしますので、適宜修正の上、再度申請して下さい。</li>
                            <li className={classes.guideLi}>商品返送手数料等には2011年の義援金を含む場合もあります。（一部の作家さんのみ）</li>
                        </ul>
                        <div style={{textAlign:'right'}}>
                            <Link to={toFirst}><Button variant="text" color="primary" startIcon={<ArrowForwardIcon/>}>ご利用ガイド</Button></Link>
                        </div>
                    </Paper>
					):(
					<Paper className={classes.paper}>
						<Title text="支払申請" size={2}/>
                        <ul className={classes.guideUl}>
                            <li className={classes.guideLi}>支払申請を行うにはプロフィールをメインプロフィールに切り替えて下さい。</li>
                        </ul>
					</Paper>
					)}
                </Grid>
            </Grid>
            <PaymentConfirm isOpen={states.isConfirm} yes={yes} no={no} payment={states.payment}/>
		</div>
	);
}

export default PaymentDetail;
